import React from 'react';
import AppTheme from '../theme/AppTheme';
import './hrm-theme.css';

// One scope for the route, embedded profile and portalled HRM overlays.
export default function HrmTheme({ children }) {
  return <AppTheme className="hrm-theme">{children}</AppTheme>;
}
